;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Bank = require('./Bank.vue');

var _Bank2 = _interopRequireDefault(_Bank);

var _SearchModal = require('./../shared/SearchModal.vue');

var _SearchModal2 = _interopRequireDefault(_SearchModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		Bank: _Bank2.default, SearchModal: _SearchModal2.default
	},
	props: {
		payment_gateways: {
			type: Object,
			required: true,
			default: []
		},
		invoice: {
			type: Object,
			required: false,
			default: {}
		},
		callback_url: {
			type: String,
			required: false,
			default: ""
		},
		status_api_url: {
			type: String,
			required: false,
			default: ""
		}
	},
	data: function data() {
		return {
			sorted_payment_gateways: [],
			show_bank: false,
			bank: {},
			show_search_modal: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		var bank_gateways = this.payment_gateways.filter(function (gateway) {
			return gateway.gateway_type === 'bank' && gateway.currency === _this.invoice.currency;
		});
		this.sorted_payment_gateways = this.groupBanksByLetter(bank_gateways);
	},

	methods: {
		showBank: function showBank(bank) {
			this.show_search_modal = false;
			this.bank = bank;
			this.show_bank = true;
		},
		groupBanksByLetter: function groupBanksByLetter(banks) {
			var grouped = {};

			banks.forEach(function (bank) {
				var firstLetter = bank.common_name[0].toUpperCase();
				if (!grouped[firstLetter]) {
					grouped[firstLetter] = [];
				}
				grouped[firstLetter].push(bank);
			});

			return (0, _keys2.default)(grouped).sort().map(function (key) {
				return { label: key, gateways: grouped[key] };
			});
		}
	},
	computed: {}
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.show_bank)?_c('section',[_c('div',{staticClass:"flex items-center justify-between mb-11 w-full"},[_c('h4',{staticClass:"text-sm font-medium tracking-[1%] leading-[22px]"},[_vm._v("\n\t\t\tBank payment\n\t\t")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"px-2 py-1 bg-[#F9F9F9] flex items-center justify-between w-[196px] rounded-md",on:{"click":function($event){_vm.show_search_modal = true}}},[_c('span',{staticClass:"inline-block text-[#909090] text-sm font-medium tracking-[1%] leading-[22px]"},[_vm._v("Search")]),_vm._v(" "),_c('svg',{attrs:{"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.66671 14.25C11.1645 14.25 14 11.4144 14 7.91665C14 4.41884 11.1645 1.58331 7.66671 1.58331C4.1689 1.58331 1.33337 4.41884 1.33337 7.91665C1.33337 11.4144 4.1689 14.25 7.66671 14.25Z","stroke":"#909090","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.6667 14.9166L13.3334 13.5833","stroke":"#909090","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])])]),_vm._v(" "),_c('div',{staticClass:"space-y-4"},_vm._l((_vm.sorted_payment_gateways),function(gateways){return _c('div',{staticClass:"flex items-start gap-4 sm:gap-6"},[_c('div',{staticClass:"w-full flex items-start gap-4 sm:gap-6"},[_c('div',[_c('span',{staticClass:"text-xs font-light leading-[20px]"},[_vm._v(_vm._s(gateways.label))])]),_vm._v(" "),_c('div',{staticClass:"w-full grid grid-cols-1 sm:grid-cols-2 gap-6"},_vm._l((gateways.gateways),function(gateway){return _c('a',{staticClass:"flex items-center gap-2 border border-[#EBF3FF] py-1.5 px-2 rounded-full hover:bg-blue-100 col-span-1 w-full hover:cursor-pointer",on:{"click":function($event){$event.preventDefault();return _vm.showBank(gateway)}}},[_c('span',{staticClass:"inline-block text-[#000007] font-medium tracking-[1%] ml-2 text-xs"},[_vm._v(_vm._s(gateway.common_name))])])}),0)])])}),0),_vm._v(" "),(_vm.show_search_modal)?_c('div',[_c('SearchModal',{attrs:{"payment_gateways":_vm.payment_gateways},on:{"hide-search-modal":function($event){_vm.show_search_modal = false},"show-bank":_vm.showBank}})],1):_vm._e()]):_c('Bank',{attrs:{"bank":_vm.bank,"invoice":_vm.invoice,"callback_url":_vm.callback_url,"status_api_url":_vm.status_api_url},on:{"showBanks":function($event){_vm.show_bank = false}}})}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c047c3a", __vue__options__)
  } else {
    hotAPI.reload("data-v-6c047c3a", __vue__options__)
  }
})()}